import { KitButton, KitIcon, KitText } from '@omni/kit/components';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import BorderRadius from '@omni/kit/theming/BorderRadius';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import { ThemeContext } from '@omni/kit/theming/ThemeContext';
import React, { ReactElement, useContext } from 'react';
import { Platform, StyleSheet, View } from 'react-native';

interface EmptyStateGroupEventProps {
  isManager: boolean;
  onPressCreateGroupEvent?: () => void;
  upcoming?: boolean;
}
export default function GroupEventsEmptyState({
  isManager,
  onPressCreateGroupEvent,
  upcoming = false,
}: EmptyStateGroupEventProps): ReactElement {
  const { colorForScheme } = useContext(ThemeContext);
  const { t } = useTranslation();

  const bgColor = colorForScheme?.({
    dark: Colors.N900,
    light: Colors.N50,
  });
  const iconColor = colorForScheme?.({
    dark: Colors.N400,
    light: Colors.N300,
  });

  const subtitleColor = colorForScheme?.({
    dark: Colors.N400,
    light: Colors.N500,
  });

  return (
    <View style={styles.emptyStateContainer}>
      <View
        style={[
          styles.emptyStateIcon,
          {
            backgroundColor: bgColor,
          },
        ]}
      >
        <KitIcon name='calendar' size={20} color={iconColor} />
      </View>
      <View>
        <KitText
          extraBold
          center
          color={Colors.N900}
          fontSize={20}
          style={{ marginBottom: Spacing.xs }}
        >
          {upcoming
            ? t('common:textNoUpcomingEvents')
            : t('common:textNoPastEvents')}
        </KitText>
        <KitText center color={subtitleColor} fontSize={16}>
          {t('groups:emptyStateGroupEventsSubtitleTitle')}
        </KitText>
        {isManager ? (
          <KitButton
            secondary
            onPress={onPressCreateGroupEvent}
            icon='icons-event'
            iconSize={14}
            testID='CreateGroupEventButton'
            style={{
              marginTop: Spacing.l,
              width: 241,
              height: 44,
              alignSelf: 'center',
            }}
            title={t('groups:createGroupEventButtonTitle')}
          />
        ) : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  emptyStateContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 32,
    marginTop: Platform.OS === 'web' ? 96 : 235,
  },
  emptyStateIcon: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: Spacing.s,
    borderRadius: BorderRadius.m,
    marginBottom: Spacing.m,
  },
});
